import { useState, useEffect } from 'react';
import { ROUTE_PATHS } from '../../shipping-line/constants';
import { useNavigate } from 'react-router-dom';

const useBetaHook = () => {
  const navigate = useNavigate();
  const [isBetaEnabled, setIsBetaEnabled] = useState(() => {
    const storedValue = localStorage.getItem('isBetaEnabled');
    if (storedValue === null) {
      localStorage.setItem('isBetaEnabled', 'true');
      return true;
    }
    return storedValue === 'true';
  });

  const toggleBeta = (betaOverride: boolean | null = null) => {
    setIsBetaEnabled(betaOverride ?? !isBetaEnabled);
    localStorage.setItem('isBetaEnabled', (betaOverride ?? !isBetaEnabled)?.toString());
    navigate(ROUTE_PATHS.BASE_ROUTE);
  };

  const isBetaKeyAvailable = Boolean(localStorage.getItem('isBetaEnabled'));
  const areBetaScreensEnabled =
    localStorage.getItem('isBetaEnabled')?.toString() === 'true' || false;

  return { isBetaEnabled, toggleBeta, areBetaScreensEnabled, isBetaKeyAvailable };
};

export default useBetaHook;
